
let env = process.env.REACT_APP_ENV
const img_path = "./img"

let  front_host = "http://localhost:3000"
let  back_host = "http://localhost:8080"

if(env === "PROD"){
	front_host = "https://pathfinder.digitalfactory.aero"
	back_host = "https://pathfinder.digitalfactory.aero"
}else if(env === "PREPROD"){
	front_host = "https://pathfinder-preprod.digitalfactory.aero"
	back_host = "https://pathfinder-preprod.digitalfactory.aero"
}else if(env === "DEV"){
	front_host = "https://pathfinder-dev.digitalfactory.aero"
	back_host = "https://pathfinder-dev.digitalfactory.aero"
}

exports.config = {
	env : env,
	front  : front_host ,
	host   : back_host + "/api",
	logo :  require(`${img_path}/logo.png`),
	majorColor : "#002943"
}